import * as React from 'react';
import { useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import { Audit } from 'lib/types';
import { useApi } from 'lib/contexts/ApplicationState';
import { CreditItem } from 'components/CreditItem';
import { AuditUserAction } from './AuditUserAction';

interface Props {
  postId: number;
}

export const AuditLogList = ({
  postId,
}: Props) => {
  const API = useApi();
  const [creditAudits, setCreditAudits] = useState<Audit[]|undefined>();
  const [tagAudits, setTagAudits] = useState<Audit[]|undefined>();

  useEffect(() => {
    const getCreditAudits = async () => {
      const data = await API.listCreditAuditsForPost(postId);
      setCreditAudits(data);
    };

    const getTagAudits = async () => {
      const audits = await API.listTagAuditsForPost(postId);
      setTagAudits(audits);
    };

    getCreditAudits();
    getTagAudits();
  }, []);

  if (!creditAudits || !tagAudits) { return null; }

  if (creditAudits.length === 0 && tagAudits.length === 0) {
    return (
      <div className="text-center border p-4 mt-4 rounded-lg">
        No history found
      </div>
    );
  }

  return (
    <div>
      {creditAudits.map((audit) => {
        const auditUser = audit.user;
        const credit = audit.fields;
        return (
          <div className="border-b px-2 py-4" key={audit.id}>
            <AuditUserAction user={auditUser} audit={audit} />
            <CreditItem credit={credit} />
          </div>
        );
      })}
      {tagAudits.map((audit) => {
        const auditUser = audit.user;
        const tag = audit.fields;
        return (
          <div className="border-b px-2 py-4" key={audit.id}>
            <AuditUserAction user={auditUser} audit={audit} />
            <div className="pt-2">
              <Chip
                size="small"
                className="text-white font-bold"
                label={tag.value || tag.tagValue}
                color="primary"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
